<template>
  <div>
    <el-radio-group v-model="path"  size="medium" @change="tabPath">
      <el-radio-button label="/recipeStatistics/satisfaction/service">维修满意度</el-radio-button>
      <el-radio-button label="/recipeStatistics/satisfaction/maintenance">保养满意度</el-radio-button>
      <el-radio-button label="/recipeStatistics/satisfaction/afterSales">售后满意度</el-radio-button>
<!--      <el-radio-button label="/recipeStatistics/satisfaction/annualStaff">年度售后员工满意度</el-radio-button>-->
    </el-radio-group>
    <div style="margin-top: 20px">
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive'></router-view>
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "anomaly",
  data() {
    return {
      path: "/recipeStatistics/satisfaction/service"
    }
  },
  created() {
    this.path=this.$route.path
  },
  component: {
    //someComponent
  },
  methods: {
    //
    tabPath(){
      this.$router.push(this.path)
    }
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>